import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
import LaloMark from './LaloMark';
/**
 * Lalo HR product lockup. The descriptor ("HR") is what distinguishes the
 * product — the mark and wordmark are identical across every Lalo product,
 * and the "Modern AI" tagline is masterbrand-only (never rendered in-app).
 */
export default function LaloLockup({ variant = 'horizontal', surface = 'ink', className, }) {
    const onInk = surface === 'ink';
    const wordmarkColor = onInk ? 'text-paper' : 'text-ink';
    const descriptorColor = onInk
        ? 'bg-lalo-grad bg-clip-text text-transparent'
        : 'text-brand-600';
    if (variant === 'stacked') {
        return (_jsxs("div", { className: cn('flex flex-col items-center', className), children: [_jsx(LaloMark, { className: "w-40", title: "Lalo HR" }), _jsx("div", { className: cn('mt-2 font-display text-[34px] leading-none uppercase tracking-wordmark indent-[.42em]', wordmarkColor), children: "LALO" }), _jsx("div", { className: cn('mt-1.5 font-display text-sm leading-none uppercase tracking-descriptor indent-[.5em]', descriptorColor), children: "HR" })] }));
    }
    return (_jsxs("span", { className: cn('flex items-center gap-3.5', className), children: [_jsx(LaloMark, { className: "w-[74px] shrink-0", title: "Lalo HR" }), _jsxs("span", { className: cn('font-display text-[19px] leading-none uppercase tracking-lockup whitespace-nowrap', wordmarkColor), children: ["LALO\u00A0\u00A0", _jsx("span", { className: descriptorColor, children: "HR" })] })] }));
}
